import React from "react";
import { colors } from '../../../../theme/colors';
import { Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const UploadZone = styled(Box)(({ hasfile }) => ({
  borderRadius: "12px",
  padding: "18px 16px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "14px",
  border: hasfile === "true" ? "2px solid #22c55e" : `2px dashed ${colors.primary}`,
  backgroundColor: hasfile === "true" ? "#f0fdf4" : "#fff9f9",
  transition: "all 0.25s ease",
  "&:hover": {
    backgroundColor: hasfile === "true" ? "#dcfce7" : "#fef2f2",
    borderColor: hasfile === "true" ? "#16a34a" : colors.primaryHover,
    transform: "translateY(-1px)",
    boxShadow:
      hasfile === "true"
        ? "0 4px 12px rgba(34, 197, 94, 0.18)"
        : `0 4px 14px ${colors.primary}33`,
  },
}));

const UploadFile = (props) => {
  const {
    label = "",
    handleGetFile,
    filename = null,
    clearFile,
    fileRef,
  } = props;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleGetFile(file);
    }
  };

  React.useEffect(() => {
    if (clearFile && fileRef.current) {
      fileRef.current.value = null;
    }
  }, [clearFile]);

  return (
    <>
      <label htmlFor={label} style={{ cursor: "pointer", display: "block" }}>
        <UploadZone hasfile={filename ? "true" : "false"}>
          <input
            accept=".pdf,.docx,.doc"
            ref={fileRef}
            style={{ display: "none" }}
            id={label}
            type="file"
            onChange={handleFileChange}
          />
          {filename ? (
            <CheckCircleIcon sx={{ fontSize: 32, color: "#22c55e", flexShrink: 0 }} />
          ) : (
            <CloudUploadIcon sx={{ fontSize: 32, color: colors.primary, flexShrink: 0 }} />
          )}
          <Box sx={{ overflow: "hidden", minWidth: 0 }}>
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{
                color: filename ? "#16a34a" : colors.primary,
                lineHeight: 1.4,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {filename ? (
                filename
              ) : (
                <>
                  Upload {label}
                  <span style={{ color: "#ef4444" }}>*</span>
                </>
              )}
            </Typography>
            <Typography variant="caption" sx={{ color: filename ? "#16a34a" : "#919EAB", display: "block" }}>
              {filename ? "File uploaded successfully" : "Click to browse • PDF, DOC, DOCX"}
            </Typography>
          </Box>
        </UploadZone>
      </label>
    </>
  );
};

export default UploadFile;
